import { Component, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Config, Nav, Platform } from 'ionic-angular';

import { FirstRunPage, MainPage,WelcomePage } from '../pages';
import { Settings } from '../providers';

//Native components
//import { OneSignal } from '@ionic-native/onesignal';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';


@Component({
  template: `<ion-menu [content]="content">
    <ion-header>
      <ion-toolbar>
        <ion-title><ion-icon name="person"></ion-icon>{{unsername}} </ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-content>
      <ion-list>
        <button menuClose ion-item *ngFor="let p of pages" (click)="openPage(p)">
          {{p.title}}
          <ion-icon item-start name="{{p.icon}}"></ion-icon>
        </button>

        <button menuClose ion-item (click)="LogOut()">
          Déconnection
          <ion-icon item-start name="ios-log-out"></ion-icon>
        </button>

      </ion-list> 

    </ion-content>

  </ion-menu>
  <ion-nav #content [root]="rootPage"></ion-nav>`
})
export class MyApp {
  landingPage = (localStorage.getItem('tuto_done')!= null && localStorage.getItem('tuto_done').length > 0) ? WelcomePage: FirstRunPage ;
  rootPage = (localStorage.getItem('token') == null || localStorage.getItem('token').length == 0) ? this.landingPage: MainPage ;
  
  unsername = localStorage.getItem('prenom')
  niveau = localStorage.getItem('level')
  @ViewChild(Nav) nav: Nav;

  pages: any[] = [
    { icon:'ios-book',title: 'Tutoriel', component: 'TutorialPage' },
    { icon:'ios-log-in',title: 'Login', component: 'WelcomePage' },
    { icon:'ios-home',title: 'Calendier', component: 'TabsPage' },
    { icon:'ios-stats',title: 'Statistiques', component: 'StatistiquesPage' },
    { icon:'cog',title: 'Paramétrages', component: 'ParametragesPage' }

  ]

  constructor(
    private translate: TranslateService, 
    platform: Platform, 
    settings: Settings, 
    private config: Config, 
    private statusBar: StatusBar, 
    //private oneSignal: OneSignal,
    private splashScreen: SplashScreen
    ) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      /* // à activer pour OneSignal
      this.oneSignal.startInit('b2f7f966-d8cc-11e4-bed1-df8f05be55ba', '703322744261');

      this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.InAppAlert);

      this.oneSignal.handleNotificationReceived().subscribe(() => {
       // do something when notification is received
      });

      this.oneSignal.handleNotificationOpened().subscribe(() => {
        // do something when a notification is opened
      });

      this.oneSignal.endInit();
      */
    });
    this.initTranslate();

    if(this.niveau =='2' ){
        this.pages = [
          { icon:'ios-book',title: 'Tutoriel', component: 'TutorialPage' },
          { icon:'ios-log-in',title: 'Login', component: 'WelcomePage' },
          { icon:'ios-home',title: 'Accueil', component: 'TabsPage' },
          { icon:'ios-stats',title: 'Statistiques', component: 'StatistiquesPage' },
          { icon:'cog',title: 'Paramétrages', component: 'ParametragesPage' }
      ]
    } else {
       this.pages = [
              { icon:'ios-book',title: 'Tutoriel', component: 'TutorialPage' },
              { icon:'ios-log-in',title: 'Login', component: 'WelcomePage' },
              { icon:'ios-home',title: 'Accueil', component: 'TabsPage' },
              { icon:'ios-stats',title: 'Statistiques', component: 'StatistiquesPage' }
          ]
    }
  }

  initTranslate() {
    // Set the default language for translation strings, and the current language.
    this.translate.setDefaultLang('en');
    const browserLang = this.translate.getBrowserLang();

    if (browserLang) {
      if (browserLang === 'zh') {
        const browserCultureLang = this.translate.getBrowserCultureLang();

        if (browserCultureLang.match(/-CN|CHS|Hans/i)) {
          this.translate.use('zh-cmn-Hans');
        } else if (browserCultureLang.match(/-TW|CHT|Hant/i)) {
          this.translate.use('zh-cmn-Hant');
        }
      } else {
        this.translate.use(this.translate.getBrowserLang());
      }
    } else {
      this.translate.use('en'); // Set your language here
    }


      this.config.set('ios', 'backButtonText', '');

  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }

  LogOut() {
    localStorage.setItem('token',null)
    localStorage.setItem('UserData',null)
    this.nav.setRoot('WelcomePage');
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts